<template>
  <div>
    <TopBar :page="topBarData" @menuItemClick="menuItemClicked" />

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="8">
          <TicketDetails />
        </v-col>

        <v-col cols="12" md="4">
          <LinkedTickets class="mb-5" />
          
          <TicketManagement class="mb-5" />

          <Notes :id="$route.params.id" notesType="ticket" />
        </v-col>
      </v-row>
    </v-container>

    <TicketAuditDialog v-model="openAudit" />
  </div>
</template>

<script>
import TopBar from "@/components/Layout/TopBar";
import TicketDetails from "@/components/Tickets/TicketDetails";
import LinkedTickets from "@/components/Tickets/LinkedTickets";
import TicketManagement from "@/components/Tickets/TicketManagement";
import TicketAuditDialog from "@/components/Tickets/Dialogs/TicketAuditDialog";
import Notes from "@/components/Globals/Notes/Notes";
import { mapState, mapActions } from 'vuex';

export default {
  components: { TopBar, TicketDetails, LinkedTickets, TicketManagement, Notes, TicketAuditDialog },

  data() {
    return {
      topBarData: {
        name: 'Loading...',
        type: 'ticket',
        showSearch: true,
        menu: false,
        breadcrumbs: [],
        additionalButtons: [],
        showBeehiveIcon: true,
        articleLink: 'tickets',
      },
      openAudit: false,
    }
  },

  computed: {
    ...mapState('tickets', ['currentTicket']),
  },

  methods: {
    ...mapActions('tickets',['fetchTicketByID']),

    menuItemClicked(item) {
      switch(item) {
        case 'audit':
          this.openAudit = true;
      }
    }
  },

  async mounted () {
    await this.fetchTicketByID(this.$route.params.id);
    this.topBarData.name = `${this.currentTicket.id} ${this.currentTicket.summary ? '-' : ''} ${this.currentTicket.summary || ''}`;
  },
}
</script>

<style lang="scss" scoped>  
::v-deep .notes {
  height: auto;
  min-height: 400px;
}
</style>